import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FinancialDocumentService {
  get baseUrl(): string {
    if (window.location.href.includes('https://hpemployeeportal.z13.web.core.windows.net') || window.location.href.includes('https://employee.upper.foundation')) {
        return 'https://health-possible-api.azurewebsites.net';
    } else if (window.location.href.includes('localhost')) {
        return 'https://localhost:5001';
    }
    return 'https://health-possible-api-qa.azurewebsites.net';
  }
  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  path = 'FinancialDocument';

  download(financialDocumentId: string): Observable<any> {
    return this.http.get<any>(
        `${this.baseUrl}/${this.path}/${financialDocumentId}/Download`,
        this.httpOptions,
    );
  }
}
